import MenuList from '../../container/MenuList';
import Head from 'next/head';
import ImageBanner from '../../components/ImageBanner';
import BannerTitle from '../../components/BannerTitle';
import axios from 'axios';

const MenuPage = ({menu}) => {
  return (
    <>
      <Head>
        <title>Shaking Crab | Menu</title>
      </Head>
      <ImageBanner
        image={`https://tools.shakingcrab.com/storage/images/0f/a841f06796dce0a91d11887cf93810.jpg`}>
        <BannerTitle title={`Our Menu`}/>
      </ImageBanner>
      <MenuList
        list={menu}
      />
    </>
  );
};

/**
 * Get API responses
 * @return {Promise<{}>}
 */
export async function getStaticProps() {
  const API_V1 = process.env.NEXT_PUBLIC_API_V1;
  const menuResp = await axios(API_V1 + 'menu');
  const menu = menuResp.data;

  return {
    props: {
      menu,
    },
    revalidate: parseInt(process.env.REVALIDATE_PERIOD_SHORT),
  };
}

export default MenuPage;
